// extracted by mini-css-extract-plugin
export var cancelButton = "_oz-5";
export var content = "_oz-3";
export var createButton = "_oz-6";
export var drawerContainer = "_oz-0";
export var footer = "_oz-2";
export var header = "_oz-1";
export var orderFormColumn = "_oz-4";